export default "/_nuxt/969c4440a3ad92c54bb055172958ab9b.svg";